import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { useSearchContext } from "../../contexts";
import { GeoGroupChooser } from "../GeoGroupChooser";
import { useTranslation } from "react-i18next";

interface GeoGroupChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const GeoGroupChooserDropdown: React.FC<GeoGroupChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Actor origin country groups")}
      counter={state.draftFilters.geoGroup.value.length}
      isExclude={state.draftFilters.geoGroup.exclude}
      onOpenChange={onOpenChange}
    >
      <GeoGroupChooser />
    </DropdownFilter>
  )
};
